<template>
  <div class="collage-photo-item__image-container" :class="{'video': isVideo}">
    <img v-lazy="media.thumb_url"  class="collage-photo-item__image" :class="{'video': isVideo}" :alt="media.id"  @dragstart.prevent v-if="!media.is_placeholder">
    <!--    <img v-lazy="'https://picsum.photos/800/600'" class="collage-photo-item__image" :alt="media.id" v-if="true">-->
    <div v-else class="skeleton-image"></div>
    <Icon v-if="isVideo && !media.is_placeholder" name="play" :width="20" class="play"/>
  </div>
</template>

<script>
import {mediaTypes} from "@/domain/galleries/constants";

export default {
  name: "ImageMedia",
  props: {
    media: {
      type: [Object, Number],
      required: true
    }
  },
  computed: {
    isVideo() {
      return this.media.media_type === mediaTypes.VIDEO;
    }
  }
}
</script>

<style scoped>

</style>